import { applyStorage, getBrowserLocalStorage } from 'axios-jwt'

// 初始化 axios-jwt 的 localStorage 存储
applyStorage(getBrowserLocalStorage())

export {
  setAuthTokens,
  getAccessToken,
  clearAuthTokens,
} from 'axios-jwt'
